import { createFileRoute } from "@tanstack/react-router";
import { MindPage } from "@/modules/mind/presentation/pages/MindPage";

export const Route = createFileRoute("/_authenticated/mind")({
  component: MindPage,
});
